import React from "react";
import style from "./style.module.css";

export interface IParagraphProps {
    title?: string;
    body: string[];
    titleStyle?: string;
    groupStyle?: string;
}

export function ParagraphGroup(props: IParagraphProps) {
    return (
        <section className={props.groupStyle || style.paragraphGroup}>
            {props.title ? <h4 className={props.titleStyle || style.title} >{props.title}</h4> : null}
            {
                props.body.map((paragraph: string, index: number) => {
                    return <p key={index} className={style.paragraph}>{paragraph}</p>;
                })
            }
        </section>
    )
}